/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  
  
  
document.addEventListener("DOMContentLoaded", () =>  {

    var divElement = document.getElementById("wrapper--narrow");
    var pElement = document.getElementById("form-success");
    var myText = "Thanks for contacting us. We'll get back to you as soon as possible.";
    console.log('document is already ready, just execute code below');
//    if($('.form-success').text()!==undefined && $('.form-success').text()!=='')
//if(document.querySelector('.form-success').text()!==undefined && document.querySelector('.form-success').text()!=='')
//if(document.getElementById("form-success").innerText.trim().length > 0) 
//if (pElement.textContent.trim() !== "")
//if (document.getElementsByTagName("form-success").innerHTML == myText)
if (document.getElementsByTagName("form-success").innerHTML == myText)
{
      console.log('document is already ready, just executed code above');
        $('.custom-form__block').hide();
        $("#custom-form__block").hide();

}
});



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
